import * as actionTypes from "../actionTypes";
import {store} from "../store";
import {encodeData, getUrlWithFilters} from "../../shared/utils/axiosUtils";
import axios from "axios";
import {APP_NAME, SIM} from "../../shared/utils/constants/general";
import {TagsService} from "../../api/tagsService";
import {DigitalContractService} from "../../api/digitalContractService";
import {getMsisdnWithoutPrefix} from "../../shared/utils/utils";
import SimService from "../../api/simService";
import {toastError, toastSuccess} from "../../shared/components/toast/Toast";
import fileSaver from 'file-saver'

let attiveCancelToken = axios.CancelToken.source();
let daAttivareCancelToken = axios.CancelToken.source();
let inAttivazioneCancelToken = axios.CancelToken.source();
let sospeseCancelToken = axios.CancelToken.source();
let sostitutiveCancelToken = axios.CancelToken.source();
let suggestionCancelToken = axios.CancelToken.source();
let edhDetailsCancelToken = axios.CancelToken.source();
let ocsDetailsCancelToken = axios.CancelToken.source();
let extrasDetailsCancelToken = axios.CancelToken.source();

export const fetchAllSimData = () => {
    return dispatch => {
        dispatch(fetchDataAttive(0, 5));
        dispatch(fetchDataInAttivazione(0, 5));
        dispatch(fetchDataDaAttivare(0, 5));
        dispatch(fetchDataSospese(0, 5));
        dispatch(fetchDataSostitutive(0, 5));
    }
}

export const fetchDataAttive = (page, rowsPerPage) => {
    const attiveState = store.getState().simReducer.attive;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(attiveState.sorting, page, rowsPerPage, integrationId, filter);
    const listaDiNumeri = {listaDiNumeri: filter.listaDiNumeri.value[0]}

    if (attiveState.loading) {
        attiveCancelToken.cancel();
        attiveCancelToken = axios.CancelToken.source();
    }

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_SIM, value: true, tab: "attive"});
        SimService.fetchAttive(encodeURI(url).replace(/\+/g, "%2B"), attiveCancelToken.token, listaDiNumeri)
            .then((res) => {
                getAttiveDataSuccess(dispatch, res.data, page, rowsPerPage);
            })
            .catch((e) => {
                console.error(e);
                dispatch(removeFilter("listaDiNumeri", "array", 0))
                if (!axios.isCancel(e)) {
                    dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "attive"});
                }
            })
    };
};

export const fetchAllSelectedAttive = (page, rowsPerPage) => {
    const attiveState = store.getState().simReducer.attive;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(attiveState.sorting, page, rowsPerPage, integrationId, filter);
    const listaDiNumeri = filter.listaDiNumeri.value


    return (dispatch) => {
        dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: true, key: "loading"});
        SimService.fetchAttive(encodeURI(url).replace(/\+/g, "%2B"), attiveCancelToken.token, listaDiNumeri)
            .then((res) => {
                dispatch({
                    type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG,
                    value: res.data.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e);
                if (!axios.isCancel(e)) {
                    dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: false, key: "loading"});
                }
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: false, key: "loading"});
            })
    };
};

export const fetchDataDaAttivare = (page, rowsPerPage) => {
    const daAttivareState = store.getState().simReducer.daAttivare;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(daAttivareState.sorting, page, rowsPerPage, integrationId, filter);
    const listaDiNumeri = {listaDiNumeri: filter.listaDiNumeri.value[0]}

    if (daAttivareState.loading) {
        daAttivareCancelToken.cancel();
        daAttivareCancelToken = axios.CancelToken.source();
    }

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_SIM, value: true, tab: "daAttivare"});
        SimService.fetchDaAttivare(encodeURI(url).replace(/\+/g, "%2B"), daAttivareCancelToken.token, listaDiNumeri)
            .then((res) => {
            dispatch({
                type: actionTypes.FETCH_SIM_DATA_SUCCESS,
                tab: "daAttivare",
                data: res.data.data,
                page: page,
                rowsPerPage: rowsPerPage,
                count: res.data.count,
            });
            dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "daAttivare"});
        }).catch((e) => {
            console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "daAttivare"});
            }
        })
    };
};

export const fetchAllSelectedDaAttivare = (page, rowsPerPage) => {
    const daAttivareState = store.getState().simReducer.daAttivare;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(daAttivareState.sorting, page, rowsPerPage, integrationId, filter);
    const listaDiNumeri = {listaDiNumeri: filter.listaDiNumeri.value[0]}


    return (dispatch) => {
        dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: true, key: "loading"});
        SimService.fetchDaAttivare(encodeURI(url).replace(/\+/g, "%2B"), attiveCancelToken.token, listaDiNumeri)
            .then((res) => {
                dispatch({
                    type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG,
                    value: res.data.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e);
                if (!axios.isCancel(e)) {
                    dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: false, key: "loading"});
                }
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: false, key: "loading"});
            })
    };
};


export const fetchDataInAttivazione = (page, rowsPerPage) => {
    const inAttivazioneState = store.getState().simReducer.inAttivazione;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(inAttivazioneState.sorting, page, rowsPerPage, integrationId, filter);
    const listaDiNumeri = {listaDiNumeri: filter.listaDiNumeri.value[0]}

    if (inAttivazioneState.loading) {
        inAttivazioneCancelToken.cancel();
        inAttivazioneCancelToken = axios.CancelToken.source();
    }

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_SIM, value: true, tab: "inAttivazione"});
        SimService.fetchInAttivazione(encodeURI(url).replace(/\+/g, "%2B"), inAttivazioneCancelToken.token, listaDiNumeri)
            .then((res) => {
            dispatch({
                type: actionTypes.FETCH_SIM_DATA_SUCCESS,
                tab: "inAttivazione",
                data: res.data.data,
                page: page,
                rowsPerPage: rowsPerPage,
                count: res.data.count,
            });
            dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "inAttivazione"});
        }).catch((e) => {
            console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "inAttivazione"});
            }
        })
    };
};

export const fetchDataSospese = (page, rowsPerPage) => {
    const sospeseState = store.getState().simReducer.sospese;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(sospeseState.sorting, page, rowsPerPage, integrationId, filter);
    const listaDiNumeri = {listaDiNumeri: filter.listaDiNumeri.value[0]}

    if (sospeseState.loading) {
        sospeseCancelToken.cancel();
        sospeseCancelToken = axios.CancelToken.source();
    }

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_SIM, value: true, tab: "sospese"});
        SimService.fetchSospese(encodeURI(url).replace(/\+/g, "%2B"), sospeseCancelToken.token, listaDiNumeri)
            .then((res) => {
            dispatch({
                type: actionTypes.FETCH_SIM_DATA_SUCCESS,
                tab: "sospese",
                data: res.data.data,
                page: page,
                rowsPerPage: rowsPerPage,
                count: res.data.count,
            });
            dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "sospese"});
        }).catch((e) => {
            console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "sospese"});
            }
        })
    };
};

export const fetchDataSostitutive = (page, rowsPerPage, allRows = false) => {
    const sostitutiveState = store.getState().simReducer.sostitutive;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(sostitutiveState.sorting, page, rowsPerPage, integrationId, filter, allRows);
    const listaDiNumeri = {listaDiNumeri: filter.listaDiNumeri.value[0]}

    if (sostitutiveState.loading) {
        sostitutiveCancelToken.cancel();
        sostitutiveCancelToken = axios.CancelToken.source();
    }

    return (dispatch) => {
        dispatch({type: actionTypes.SET_LOADING_SIM, value: true, tab: "sostitutive"});
        SimService.fetchSostitutive(encodeURI(url).replace(/\+/g, "%2B"), sostitutiveCancelToken.token, listaDiNumeri)
            .then((res) => {
            dispatch({
                type: actionTypes.FETCH_SIM_DATA_SUCCESS,
                tab: "sostitutive",
                data: res.data.data,
                page: page,
                rowsPerPage: rowsPerPage,
                count: res.data.count,
            });
            dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "sostitutive"});
        }).catch((e) => {
            console.error(e);
            if (!axios.isCancel(e)) {
                dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "sostitutive"});

            }
        })
    };
};

export const fetchAllSelectedSostitutive = (page, rowsPerPage) => {
    const sostitutiveState = store.getState().simReducer.sostitutive;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(sostitutiveState.sorting, page, rowsPerPage, integrationId, filter);
    const listaDiNumeri = {listaDiNumeri: filter.listaDiNumeri.value[0]}


    return (dispatch) => {
        dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: true, key: "loading"});
        SimService.fetchSostitutive(encodeURI(url).replace(/\+/g, "%2B"), attiveCancelToken.token, listaDiNumeri)
            .then((res) => {
                dispatch({
                    type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG,
                    value: res.data.data,
                    key: 'data'
                })
            })
            .catch((e) => {
                console.error(e);
                if (!axios.isCancel(e)) {
                    dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: false, key: "loading"});
                }
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_ALL_SELECTED_ATTIVE_LOADNIG, value: false, key: "loading"});
            })
    };
};

export const setSimSelectedTab = (value) => {
    return {
        type: actionTypes.SIM_SET_SELECTED_TAB,
        selectedTab: value,
    };
};

export const simSetSelectedRowSchedaTehnica = (seriale) => {
    let selectedRowState = store.getState().simReducer.simSelectedRow;
    let selectedCompanyCode = store.getState().authReducer.selectedCompany.integrationId;
    let uid = store.getState().authReducer.userClaims.uid;

    return (dispatch) => {
        if (!selectedRowState.livelloDiAssistenza) {
            dispatch({type: actionTypes.FETCH_SIM_START, tab: "details"});
            SimService.fetchSchedaTecnica(seriale, selectedCompanyCode, uid).then((res) => {
                // error message handling for response of Sdno
                if (res.data.hasSdnoAllowedListForSimError) {
                    console.error(res.data.sdnoSdnoAllowedListForSimErrorMessage);
                }
                if (res.data.hasSdnoBlockedNumbersError) {
                    console.error(res.data.sdnoSdnoBlockedNumbersErrorMessage);
                }
                if (res.data.hasSdnoBlockedNumbersError || res.data.hasSdnoAllowedListForSimError) {
                    toastError("Si è verificato un problema nel recupero delle informazioni. Riprova più tardi.");
                }
                dispatch({
                    type: actionTypes.SIM_SET_SELECTED_TABLE_ROW,
                    selectedRow: {
                        ...selectedRowState,
                        ...res.data
                    },
                });
            }).catch((e) => {
                dispatch({type: actionTypes.FETCH_SIM_ERROR, tab: "details", value: true});
                toastError(e.response.data.message);
                console.log(e.response.data.message);
            }).finally(() => {
                dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "details"});
            });
        }
    };
};

export const simSetSelectedRowOfferta = (seriale, tipologia) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const selectedRowState = store.getState().simReducer.simSelectedRow;
    const msisdn = store.getState().simReducer.edhDetails.msisdn;
    return (dispatch) => {
        dispatch({type: actionTypes.FETCH_SIM_START, tab: "details"});
        SimService.fetchOfferta(seriale, tipologia, integrationId).then((res) => {
            dispatch({
                type: actionTypes.SIM_SET_SELECTED_TABLE_ROW,
                selectedRow: {
                    ...selectedRowState,
                    ...res.data,
                },
            });
            callGetBulkListForSim(dispatch, integrationId, getMsisdnWithoutPrefix(msisdn))
        }).catch((e) => {
            dispatch({type: actionTypes.FETCH_SIM_ERROR, tab: "details", value: true});
            console.log(e);
        }).finally(() => {
            dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "details"});
        });
    };
};

export const downloadSimsFromOrderCsv = (setIsFileDownloading) => {
    setIsFileDownloading(true);
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const orderId = store.getState().ordiniDiSpedizioneReducer.selectedRow.rowId;
    SimService.downloadCsvFromOrder(orderId, integrationId).then((response) => {
            setIsFileDownloading(false);
            fileSaver.saveAs(response.data, `sims-${orderId}.csv`);
        }
    ).catch(() => {
        setIsFileDownloading(false);
    })
}

export const setDashboardValue = (value, index) => {
    return {
        type: actionTypes.SIM_SET_DASHBOARD,
        value: value,
        tabIndex: index,
    };
};

export const setSortingSIM = (value, tab) => {
    return {
        type: actionTypes.SET_SORTING_SIM,
        value: value,
        tab: tab,
    };
};

export const changeFilterSim = (name, value, date, text = "") => {
    return {
        type: actionTypes.CHANGE_FILTER_SIM,
        name: name,
        value: value,
        date: date,
        text: text
    };
};

export const resetFilterSim = (val) => {
    return {
        type: actionTypes.RESET_FILTER_SIM,
        value: val
    };
};

export const setFilterClicked = (val) => {
    return {
        type: actionTypes.SET_FILTER_CLICKED,
        val: val,
    };
};

export const getSimIccIdList = (sims) => {
    return sims.map(s => s.seriale);
}

export const removeFilter = (name, type, idx) => {
    let val;
    let date = "";
    if (type === "array") {
        val = [...store.getState().simReducer.filter[`${name}`].value];
        val.splice(idx, 1);
    } else if (type === "date") {
        val = {...store.getState().simReducer.filter[`${name}`]};
        val.from = null;
        val.to = null;
        date = "r";
    } else {
        val = "";
    }
    return {
        type: actionTypes.CHANGE_FILTER_SIM,
        name: name,
        value: val,
        date: date,
    };
};

const getAttiveDataSuccess = (dispatch, data, page, rowsPerPage) => {
    dispatch({
        type: actionTypes.FETCH_SIM_DATA_SUCCESS,
        tab: "attive",
        data: data.data,
        page: page,
        rowsPerPage: rowsPerPage,
        count: data.count,
    });
    dispatch({type: actionTypes.SET_LOADING_SIM, value: false, tab: "attive"});
    dispatch({type: actionTypes.SET_WRENCH_LOADING_ATTIVE, value: true});
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const wrenchSimDetailsDto = {
        simIccIdList: getSimIccIdList(data.data),
        integrationId: integrationId
    }
    SimService.fetchWrenchDetails(wrenchSimDetailsDto).then((res) => {
        dispatch({type: actionTypes.SET_WRENCH_DETAILS_ATTIVE, wrenchDetails: res.data})
    }).catch((e) => {
        console.log(e);
    }).finally(() => {
        dispatch({type: actionTypes.SET_WRENCH_LOADING_ATTIVE, value: false});
    })
}

export const changeAutocompleteListForSelectedSim = (autocompleteList, type) => {
    const autocompleteListState = [...store.getState().simReducer.extrasDetails[type]]
    const tmpList = []
    autocompleteListState.forEach(i => {
        let tmpObj = autocompleteList.find(c => c.id === i.id)
        if (tmpObj) {
            tmpObj.checked = true
        } else {
            tmpObj = i
            tmpObj.checked = false
        }
        tmpList.push(tmpObj)
    })
    return {
        type: actionTypes.CHANGE_AUTOCOMPLETE_LIST_FOR_SELECTED_SIM,
        autocompleteList: tmpList,
        forType: type
    };
}

export const fetchSimFilterData = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const collaborators = store.getState().deviceReducer.filterData.collaborators;

    return dispatch => {
        dispatch({type: actionTypes.SET_SIM_FILTER_LOADING_OR_ERROR, label: "error", value: false})
        dispatch({type: actionTypes.SET_SIM_FILTER_LOADING_OR_ERROR, label: "loading", value: true})
        SimService.fetchFilterData(integrationId, collaborators.length === 0).then((res) => {
            dispatch({
                type: actionTypes.SET_SIM_FILTER_INPUT_DATA,
                response: collaborators.length === 0 ? res.data : {...res.data, collaborators: collaborators}
            })
        }).catch((e) => {
            console.log(e);
            dispatch({type: actionTypes.SET_SIM_FILTER_LOADING_OR_ERROR, label: "error", value: true})
        }).finally(() => {
            dispatch({type: actionTypes.SET_SIM_FILTER_LOADING_OR_ERROR, label: "loading", value: false})
        })
    }
}

export const fetchNumbersBlockedList = (uid, integrationId, simList, handleDialogClose) => {
    const sdnoRequestDto = {
        uid: uid,
        integrationId: integrationId,
        simList: simList
    }
    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_NUMBERS_BLOCKED_LIST, value: true});
        SimService.fetchNumeriBloccatti(sdnoRequestDto)
            .then((res) => {
                dispatch({
                    type: actionTypes.FETCH_NUMBERS_BLOCKED_LIST,
                    numbersBlockedList: res.data
                })
            })
            .catch((e) => {
                handleDialogClose();
                console.error(e.response.data.message)
                toastError(e.response.data.message)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_LOADING_NUMBERS_BLOCKED_LIST, value: false});
            })
    }
}

export const handleNumberBlockedListChange = (numberBlockedList) => {
    return {
        type: actionTypes.HANDLE_NUMBER_BLOCKED_LIST_CHANGE,
        numbersBlockedList: numberBlockedList
    };
}

export const clearNumberBlockedList = () => {
    return {
        type: actionTypes.CLEAR_NUMBER_BLOCKED_LIST
    }
}

export const fetchSimFilterSuggestions = (type, searchText) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const suggestionsLoading = store.getState().simReducer.simSuggestion.loading;
    const listaDiNumeriValidationError = store.getState().authReducer.frontendConfiguration?.listaDiNumeriValidationError;
    let query = ""
    if(type==="listaDiNumeri"){
        query = encodeData(`?integrationId=${integrationId}`)
    } else{
        query = encodeData(`?integrationId=${integrationId}&${type}=${searchText}`)
    }
    if (suggestionsLoading) {
        suggestionCancelToken.cancel();
        suggestionCancelToken = axios.CancelToken.source();
    }

    let listaDiNumeriValue = type === "listaDiNumeri" ? searchText : null;

    return dispatch => {
        dispatch(setLoadingSuggestionSim(true))
        SimService.fetchFilterSuggestions(query, suggestionCancelToken.token, {listaDiNumeri: listaDiNumeriValue})
            .then((res) => {
            dispatch({
                type: actionTypes.SET_SIM_FILTER_SUGGESTION_DATA,
                suggestionList: type === "numeroSeriale" ? res.data.data.map(d => {
                    return {
                        text: d.iccId
                    }
                }) : res.data.data.map(d => {
                    return {
                        text: d.msisdn
                    }
                })
            })
            dispatch(setLoadingSuggestionSim(false))
        }).catch((e) => {
            if(e.response.data.validationErrors.errors[0].includes("1000")) {
                toastError(listaDiNumeriValidationError)
                dispatch(removeFilter("listaDiNumeri", "array", 0))
            }
            if (!axios.isCancel(e)) {
                dispatch(setLoadingSuggestionSim(false))
            }
        })
    }
}

export const setLoadingSuggestionSim = (val) => {
    return {type: actionTypes.SET_SIM_SUGGESTION_LOADING, value: val}
}

export const updateSimTagsAssociations = (tags, clientName, objectCategoryName, objectExternalId, updatedTags, tab) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const body = {
        tags: tags,
        clientName: clientName,
        objectCategoryName: objectCategoryName,
        integrationId: integrationId,
        objectExternalId: objectExternalId
    }

    return dispatch => {
        TagsService.updateAssociations(body).then((res) => {
            console.log(res.data)
            dispatch({
                type: actionTypes.UPDATE_CHANGED_TAGS_SIM,
                tab: tab,
                updatedTags: updatedTags,
                seriale: objectExternalId
            })
        }).catch(e => {
            console.log(e);
        })
    }
}

export const checkForWrenchDetailsInModal = (simIccIdList, tab) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const wrenchSimDetailsDto = {
        simIccIdList: simIccIdList,
        integrationId: integrationId
    }

    return dispatch => {
        dispatch({type: actionTypes.SET_ACTIVE_SERVICE_REQUEST, typeOf: "loading", value: true})
        SimService.checkWrenchDetails(wrenchSimDetailsDto).then((res) => {
            if (res.data.filter(wrench => wrench.showWrench).length === 0) {
                dispatch({type: actionTypes.SET_ACTIVE_SERVICE_REQUEST, typeOf: "value", value: false})
            } else {
                dispatch({type: actionTypes.SET_ACTIVE_SERVICE_REQUEST, typeOf: "value", value: true})
                toastError("Richiesta di servizio già in corso per alcune delle SIM selezionate");
            }
            if (tab === "attive") {
                dispatch({type: actionTypes.SET_WRENCH_DETAILS_ATTIVE, wrenchDetails: res.data})
            } else if (tab === "inAttivazione") {
                dispatch({type: actionTypes.SET_WRENCH_DETAILS_IN_ATTIVAZIONE, wrenchDetails: res.data})
            }
        }).catch((e) => {
            console.log(e);
        }).finally(() => {
            dispatch({type: actionTypes.SET_ACTIVE_SERVICE_REQUEST, typeOf: "loading", value: false})
            dispatch({type: actionTypes.SET_ACTIVE_SERVICE_REQUEST, typeOf: "value", value: false})
        })
    }
}

export const fetchSimTagsAutocomplete = (name) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return dispatch => {
        TagsService.fetchTagsAutocomplete(integrationId, SIM, APP_NAME, name).then(res => {
            dispatch({type: actionTypes.UPDATE_SIM_TAGS_AUTOCOMPLETE_SUCCESS, payload: res.data.data.reverse()})
        }).catch(e => {
            console.log(e);
        })
    }
}

export const fetchAssociatedBulksForSim = (msisdn) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return dispatch => {
        callGetBulkListForSim(dispatch, integrationId, msisdn)
    }
}

export const disassociateSimFromBulk = (groupKey, msisdn) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    const deleteGroupMemberDto = {
        integrationId: integrationId,
        groupKey: groupKey,
        msisdnList: [msisdn]
    }

    return dispatch => {
        dispatch({
            type: actionTypes.SET_LOADING_BULK_LIST_ASSOCIATED_TO_SIM,
            name: "loading",
            loading: true
        })
        DigitalContractService.deleteGroupMembers(deleteGroupMemberDto)
            .then(() => {
                callGetBulkListForSim(dispatch, integrationId, msisdn)
                toastSuccess("Operazione avvenuta con successo.")
            })
            .catch(e => {
                console.log(e)
                toastError("Operazione non riuscita. Riprovare.")
            })
    }
}

const callGetBulkListForSim = (dispatch, integrationId, msisdn) => {
    dispatch({type: actionTypes.SET_LOADING_BULK_LIST_ASSOCIATED_TO_SIM, name: "loading", loading: true})
    DigitalContractService.fetchBulkListForSim(integrationId, msisdn).then(res => {
        dispatch({
            type: actionTypes.FETCH_BULK_LIST_ASSOCIATED_TO_SIM,
            data: res.data.bulkList
        })
    }).catch(e => {
        console.log(e)
    }).finally(() => {
        dispatch({type: actionTypes.SET_LOADING_BULK_LIST_ASSOCIATED_TO_SIM, name: "loading", loading: false})
    })
}

export const fetchIpAddressesForSim = (iccId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    const userId = store.getState().authReducer.userClaims.uid

    const fetchIpAddressesDto = {
        integrationId: integrationId,
        userId: userId,
        iccId: iccId
    }

    return dispatch => {
        dispatch({type: actionTypes.SET_CHANGE_IP_VALUES, name: "menuItemsLoading", payload: true})
        SimService.fetchIpAddresses(fetchIpAddressesDto)
            .then(res => {
                dispatch({
                    type: actionTypes.SET_CHANGE_IP_VALUES,
                    name: "menuItems",
                    payload: [...res.data.value.ipAddresses, {value: "", text: ""}]
                })
            })
            .catch(e => {
                dispatch({
                    type: actionTypes.SET_CHANGE_IP_VALUES,
                    name: "menuItems",
                    payload: []
                })
                console.error(e.response.data.message)
                toastError(`Si è verificato un errore durante il recupero degli indirizzi IP per la SIM: ${iccId}`)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_CHANGE_IP_VALUES, name: "menuItemsLoading", payload: false})
            })
    }
}

export const disassociateSimFromUser = (msisdnList, sendNotification) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const disassociateSimDto = {
        msisdnList: msisdnList,
        sendNotification: sendNotification
    }

    SimService.disassociateSimForUser(integrationId, disassociateSimDto).then(() => {
        toastSuccess("SIM dissociate con successo dall'utente")
    }).catch(e => {
        console.log(e)
        toastError("Si è verificato un errore durante la disassociazione delle SIM dall'utente")
    })
}

export const getCollaboratorsForSims = (customerId, iccidList, areAllSelected = false) => {
    const getCollaboratorsDto = {
        customerId: customerId,
        iccidList: iccidList,
        areAllSelected: areAllSelected
    }

    return dispatch => {
        dispatch({type: actionTypes.SET_LOADING_COLLABORATORS_SIM, loading: true})
        dispatch({type: actionTypes.SET_ERROR_COLLABORATORS_SIM, payload: false})
        SimService.fetchCollaborators(getCollaboratorsDto, constructSimQuery(customerId)).then(res => {
            dispatch({
                type: actionTypes.GET_COLLABORATORS_SIM,
                collaborators: res.data
            })
        }).catch(e => {
            console.log(e);
            dispatch({type: actionTypes.SET_ERROR_COLLABORATORS_SIM, payload: true})
        }).finally(() => {
            dispatch({type: actionTypes.SET_LOADING_COLLABORATORS_SIM, loading: false});
        })
    }
}

export const addCollaboratorsForSim = (collaboratorsList, iccidList, customerId, areAllSelected) => {
    const addCollaboratorsDto = {
        getCollaboratorsResponseDtoList: collaboratorsList,
        idList: iccidList,
        customerId: customerId,
        areAllSelected: areAllSelected
    }

    SimService.addCollaborators(addCollaboratorsDto, constructSimQuery(customerId)).then(() => {
        // This may take longer then expected because it's async and going through RabbitMQ
        toastSuccess("Operazione presa in carico")
    }).catch(e => {
        console.log(e);
    })
}

export const getSimEdhDetails = (simDetailsDto, simGroup) => {
    const edhDetailsLoading = store.getState().simReducer.edhDetails.loading;
    if (edhDetailsLoading) {
        edhDetailsCancelToken.cancel();
        edhDetailsCancelToken = axios.CancelToken.source();
    }

    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
            typeOf: 'edhDetails',
            key: 'loading',
            value: true
        })
        dispatch({
            type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
            typeOf: 'edhDetails',
            key: 'error',
            value: false,
            errorStatusCode: 200,
            errorMessage: ''
        })
        dispatch({type: actionTypes.FETCH_SIM_ERROR, tab: "details", value: false});
        SimService.fetchEdhDetails(simDetailsDto, simGroup, edhDetailsCancelToken.token).then((res) => {
            // We need this state in simSelectedRow for scheda modals
            const mappedToSerialeAndNumeroDiTelefono = {
                seriale: simDetailsDto.iccId,
                numeroDiTelefono: simDetailsDto.msisdn,
            }
            dispatch({
                type: actionTypes.SET_SIM_DETAILS,
                typeOf: 'edhDetails',
                payload: res.data,
                dto: mappedToSerialeAndNumeroDiTelefono
            })
            dispatch({
                type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                typeOf: 'edhDetails',
                key: 'loading',
                value: false
            })
        }).catch((err) => {
            if (!axios.isCancel(err)) {
                console.log(err)
                dispatch({
                    type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                    typeOf: 'edhDetails',
                    key: 'loading',
                    value: false
                })
                dispatch({
                    type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                    typeOf: 'edhDetails',
                    key: 'error',
                    value: true,
                    errorStatusCode: err.response.data.status,
                    errorMessage: err.response.data.message.includes("La SIM") ? err.response.data.message : undefined
                })
            }
        })
    }
}

export const getSimOcsDetails = (simDetailsDto) => {
    const ocsDetailsLoading = store.getState().simReducer.ocsDetails.loading;
    if (ocsDetailsLoading) {
        ocsDetailsCancelToken.cancel();
        ocsDetailsCancelToken = axios.CancelToken.source();
    }

    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
            typeOf: 'ocsDetails',
            key: 'loading',
            value: true
        })
        dispatch({type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS, typeOf: 'ocsDetails', key: 'error', value: false})
        SimService.fetchOcsDetails(simDetailsDto, ocsDetailsCancelToken.token).then((res) => {
            dispatch({type: actionTypes.SET_SIM_DETAILS, typeOf: 'ocsDetails', payload: res.data})
            dispatch({
                type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                typeOf: 'ocsDetails',
                key: 'loading',
                value: false
            })
        }).catch((err) => {
            if (!axios.isCancel(err)) {
                console.log(err)
                dispatch({
                    type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                    typeOf: 'ocsDetails',
                    key: 'loading',
                    value: false
                })
                dispatch({
                    type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                    typeOf: 'ocsDetails',
                    key: 'error',
                    value: true
                })
            }
        })
    }
}

export const getSimExtrasDetails = (simDetailsDto, tags) => {
    const extrasDetailsLoading = store.getState().simReducer.ocsDetails.loading;
    if (extrasDetailsLoading) {
        extrasDetailsCancelToken.cancel();
        extrasDetailsCancelToken = axios.CancelToken.source();
    }

    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
            typeOf: 'extrasDetails',
            key: 'loading',
            value: true
        })
        dispatch({
            type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
            typeOf: 'extrasDetails',
            key: 'error',
            value: false
        })
        SimService.fetchExtrasDetails(simDetailsDto, extrasDetailsCancelToken.token).then((res) => {
            const joinedTags = [...tags, ...res.data.tagsForSim];
            const joinedFirstTags = joinedTags.map(t => {
                return {...t}
            })
            dispatch({
                type: actionTypes.SET_SIM_DETAILS,
                typeOf: 'extrasDetails',
                payload: {...res.data, tagsForSim: joinedTags, firstRenderTags: joinedFirstTags}
            })
            dispatch({
                type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                typeOf: 'extrasDetails',
                key: 'loading',
                value: false
            })
        }).catch((err) => {
            if (!axios.isCancel(err)) {
                console.log(err)
                dispatch({
                    type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                    typeOf: 'extrasDetails',
                    key: 'loading',
                    value: false
                })
                dispatch({
                    type: actionTypes.SET_LOADING_OR_ERROR_SIM_DETAILS,
                    typeOf: 'extrasDetails',
                    key: 'error',
                    value: true
                })
            }
        })
    }
}

export const getSimGroupCount = (simGroup) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return dispatch => {
        dispatch({type: actionTypes.SET_SIM_GROUP_COUNT_LOADING, payload: true, key: simGroup})
        SimService.fetchSimGroupCount(integrationId, simGroup).then(res => {
            dispatch({
                type: actionTypes.FETCH_SIM_GROUP_COUNT_SUCCESS,
                payload: res.data,
                key: simGroup
            })
        }).catch(e => {
            console.log(e);
        }).finally(() => {
            dispatch({type: actionTypes.SET_SIM_GROUP_COUNT_LOADING, payload: false, key: simGroup})
        })
    }
}

export const downloadSimsCsv = (selectedSims, simGroup, areAllSelected, isMassiveTag) => {
    const sorting = store.getState().simReducer[simGroup].sorting;
    const filter = store.getState().simReducer.filter;
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const url = getUrlWithFilters(sorting, 0, 25, integrationId, filter);
    const encodedUrl = encodeURI(url).replace(/\+/g, "%2B");
    const listaDiNumeri = filter.listaDiNumeri.value[0]
    return (dispatch) => {
        dispatch({type: actionTypes.SET_SIM_CSV_DOWNLOAD_LOADING, key: simGroup, payload: true})
        SimService.downloadCsv(selectedSims, encodedUrl, simGroup, areAllSelected, isMassiveTag ?? false, listaDiNumeri).then((res) => {
            fileSaver.saveAs(res.data, `${simGroup}_${new Date().toISOString()}.csv`)
        }).catch((e) => {
            toastError('Errore durante il download del file CSV')
            console.error(e)
        }).finally(() => {
            dispatch({type: actionTypes.SET_SIM_CSV_DOWNLOAD_LOADING, key: simGroup, payload: false})
        })
    }
}

const constructSimQuery = (integrationId) => {
    const filter = store.getState().simReducer.filter;
    const selectedTab = store.getState().simReducer.selectedTab
    let url = getUrlWithFilters("", 0, 25, integrationId, filter);
    switch (selectedTab) {
        case 0:
            url += '&statoTecnico=ATTIVA';
            break; // selectedTab is Attive
        case 1:
            url += '&statoTecnico=IN_LAVORAZIONE';
            break; // selectedTab is In attivazione
        case 2:
            url += '&statoTecnico=SOSPESA';
            break; // selectedTab is Sospese
        case 3:
            url += '&statoLogistico=CONSEGNATO&statoTecnico=IN_LAVORAZIONE&codiceProdotto=60A';
            break; // selectedTab is Da attivare
        case 4:
            url += '&statoTecnico=PREATTIVA&cardType=BIANCHE';
            break; // selectedTab is Sostitutive
        default:
            break;
    }
    return url
}

export const getSimsToBeRechargedData = (page, size, sort, filter) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    const msisdn = filter.msisdn.value === "" ? null : filter.msisdn.value
    return (dispatch) => {
        dispatch({type: actionTypes.FETCH_SIMS_TO_BE_RECHARGED, key: "loading", value: true})
        SimService.fetchSimsToBeRecharged(integrationId, msisdn, page, size, sort)
            .then((res) => {
                dispatch({
                    type: actionTypes.FETCH_SIMS_TO_BE_RECHARGED,
                    value: res.data,
                    key: "data"
                })
            })
            .catch((e) => {
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({type: actionTypes.FETCH_SIMS_TO_BE_RECHARGED, key: "loading", value: false})
            })
    }
}

export const addRechargeProperties = (requestBody, calledFrom) => {
    const isAutomaticaFast = store.getState().authReducer.frontendConfiguration.AutomaticaFAST === "1";
    return (dispatch) => {
        dispatch({type: actionTypes.ADD_RECHARGE_PROPERTIES, value: true, key: 'loading'})
        SimService.addRechargeProperties(requestBody)
            .then((res) => {
                toastSuccess("Successo")
                dispatch({
                    type: actionTypes.ADD_RECHARGE_PROPERTIES,
                    value: res.data,
                    key: 'data'
                })
                if(calledFrom === "simDialog"){
                    dispatch({
                        type: actionTypes.UPDATE_THRESHOLD,
                        changedItems: requestBody,
                        isAutomaticaFast: isAutomaticaFast
                    })
                }
            })
            .catch((e) => {
                console.error(e.response.data)
                dispatch({
                    type: actionTypes.ADD_RECHARGE_PROPERTIES,
                    value: e.response.data.status,
                    key: 'data'
                })
                toastError(e.response.data.message)
            })
            .finally(() => {
                dispatch({type: actionTypes.ADD_RECHARGE_PROPERTIES, value: false, key: 'loading'})
            })
    }
}

export const clearAddRechargeResponse = () => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.ADD_RECHARGE_PROPERTIES,
            value: "",
            key: 'data'
        })
    }
}

export const getESimQrDetails = (iccid) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.GET_E_SIM_QR_AND_LOADING, key: "error", value: false})
        dispatch({
            type: actionTypes.GET_E_SIM_QR_AND_LOADING,
            key: "loading",
            value: true
        })
        SimService.fetchESim(integrationId, iccid)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_E_SIM_QR_AND_LOADING,
                    value: res.data,
                    key: "data"
                })
            })
            .catch((e) => {
                dispatch({type: actionTypes.GET_E_SIM_QR_AND_LOADING, key: "error", value: true})
                console.error(e.response.data)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_E_SIM_QR_AND_LOADING,
                    key: "loading",
                    value: false,
                })
            })
    }
}

export const distribuzioneDigitaleEsim = (emailReferente, distribuzioneList, password, openConfirmationDialog) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({
            type: actionTypes.DISTRIBUZIONE_DIGITALE,
            key: 'loading',
            value: true,
        })
        SimService.distribuzioneDigitaleEsim(integrationId, emailReferente, distribuzioneList, password)
            .then((res) => {
                dispatch({
                    type: actionTypes.DISTRIBUZIONE_DIGITALE,
                    key: 'data',
                    value: res.data,
                })
            openConfirmationDialog()
            })
            .catch(err => {
                console.log(err)
                toastError("Operazione non riuscita")
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.DISTRIBUZIONE_DIGITALE,
                    key: 'loading',
                    value: false,
                })
            })
    }
}

export const distribuzioneDigitaleEsimSostitutive = (emailReferente, distribuzioneList, password, openConfirmationDialog) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({
            type: actionTypes.DISTRIBUZIONE_DIGITALE,
            key: 'loading',
            value: true,
        })
        SimService.distribuzioneDigitaleEsimSostitutive(integrationId, emailReferente, distribuzioneList, password)
            .then((res) => {
                dispatch({
                    type: actionTypes.DISTRIBUZIONE_DIGITALE,
                    key: 'data',
                    value: res.data,
                })
                openConfirmationDialog()
            })
            .catch(err => {
                console.log(err)
                toastError("Operazione non riuscita")
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.DISTRIBUZIONE_DIGITALE,
                    key: 'loading',
                    value: false,
                })
            })
    }
}


